import React, {Component} from "react";
import {PropTypes} from "Subschema";
import CheckLess from "./Check.less";
import FloatingStyle from "../../labels/FloatingLabel.less";
//var api = require('../create');
export default class Check extends Component {
    static propTypes = {
        accountNumber: PropTypes.value,
        routingNumber: PropTypes.value
    };
    state = {
        highlight: 'none',
        routingNumber: ''
    };

    handleRoutingNumber = (routingNumber)=> {
        this.setState({routingNumber});
    };

    handleAccountNumber = (accountNumber) => {
        if (accountNumber && accountNumber.length > 8) {
            var routingNumber = this.state.routingNumber;
            this.setState({loading: true});
            /*  api.csrf().then((data)=> {
             var {_csrf} = data || {};
             fetchp('/signup/getBankName', {
             body: JSON.stringify({accountNumber, routingNumber, _csrf}),
             method: 'POST'
             }).then(this.processResponse, function (e) {
             console.log('an error occorred fetching', accountNumber);
             this.setState({loading: false});
             });
             }, function (e) {
             console.log('an error occorred fetching', accountNumber);
             this.setState({loading: false});
             })*/
        } else {
            this.setState({loading: false, name: null});
        }
    };

    processResponse = (data)=> {
        var {name, _type, countryCode, branchLocation} = data || {};
        this.setState({name, _type, countryCode, branchLocation, loading: false});
    };

    handleFocus = (e)=> {
        const highlight = e.target.name.replace(/.*\.(.*)Number/, '$1');
        this.setState({highlight});

    };
    handleBlur = (e)=> {
        this.setState({highlight:'none'});
    };
    renderBankInfo() {
        if (!this.state.name) {
            return null;
        }
        return <div key="bank" className={`${CheckLess.bankInfo} ${CheckLess.bankRetrieved}`}>
            <div className="" id="bankDetails">
                <div><h3 id="bankName" className="pv_bank-name">{this.state.name}</h3>
                </div>
            </div>
        </div>
    }

    render() {
        const {children, ...props} = this.props;
        return (<div>
            <div className={CheckLess.check}>
                <span className={`${CheckLess.focus} ${CheckLess[this.state.highlight]}`}/>
            </div>
            <div className={FloatingStyle.combined50} onFocus={this.handleFocus} onBlur={this.handleBlur}>
                {children}
            </div>
            {this.renderBankInfo()}
        </div>);
    }
}



/** WEBPACK FOOTER **
 ** ./src/templates/check/Check.jsx
 **/